import { render, staticRenderFns } from "./problemFollowCheckTask.vue?vue&type=template&id=6d844686&scoped=true&"
import script from "./problemFollowCheckTask.vue?vue&type=script&lang=js&"
export * from "./problemFollowCheckTask.vue?vue&type=script&lang=js&"
import style0 from "./problemFollowCheckTask.vue?vue&type=style&index=0&id=6d844686&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d844686",
  null
  
)

export default component.exports